import { concourseId } from '@/constants/activity-constants'
import SignService from '@/services/sign-service'
import { useEffect, useState } from 'react'

function listenEvent(callback: () => void) {
  document.addEventListener('update-total-signs', callback)
  return () => document.removeEventListener('update-total-signs', callback)
}
export function emitUpdateTotalSigns() {
  document.dispatchEvent(new CustomEvent('update-total-signs'))
}

function requestTotalSigns(): Promise<number> {
  return SignService.getTotalSigns(concourseId).then(response => {
    if (response.status === 200) {
      return response.data?.data.participations || 0
    }

    return 0
  })
}
export default function useTotalSigns(): [number, () => Promise<number>] {
  const [totalSigns, setTotal] = useState(0)
  const requestTotal = () => {
    return requestTotalSigns().then(_total => {
      setTotal(_total)
      return _total
    })
  }

  useEffect(() => {
    requestTotal()
    const unbindListener = listenEvent(() => requestTotal())
    return () => unbindListener()
  }, [])

  return [totalSigns, requestTotal]
}
